export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ01.95beae37.mp3";